interface IsHubspotFrequencyRulesErrorParams {
  message: string
}

/**
 * HubSpot's web-interactives embed (`js.hubspot.com/web-interactives-embed.js`) logs this exact
 * prefix via `console.error` — which RUM captures as a `source:console` error — then appends the
 * underlying `Failed to open IndexedDB` throw, whenever it cannot open IndexedDB while caching its
 * frequency rules (e.g. blocked/unavailable browser storage). The throw carries zero settle-web
 * frames and the page keeps working, so it is non-actionable vendor noise. We match HubSpot's
 * phrase rather than the generic IndexedDB text so a real app-side storage error stays reported.
 */
const HUBSPOT_FREQUENCY_RULES_ERROR_MESSAGE = 'eagerly loading saved frequency rules'

export const isHubspotFrequencyRulesError = ({ message }: IsHubspotFrequencyRulesErrorParams): boolean =>
  message.includes(HUBSPOT_FREQUENCY_RULES_ERROR_MESSAGE)
